import { all } from 'redux-saga/effects';
import getLeadsStatusSaga from './get_lead_status.saga';
import getLeadProfileSaga from './get_lead_profile.saga';
import getBlemishReportSaga from './questions.sagas/get_blemish_report.saga';

import assignLeadSaga from '../../../Manage_retail/redux/sagas/assign_lead.saga';
import leadManageChangeLeadStatusSaga from '../../../Manage_retail/redux/sagas/change_lead_status.saga';
import deleteLeadSaga from '../../../Manage_retail/redux/sagas/delete_lead.saga';
import getLeadsAffiliateSaga from '../../../Manage_retail/redux/sagas/get_lead_affiliate.saga';
import getLeadsDivisionsSaga from '../../../Manage_retail/redux/sagas/get_lead_divisions.saga';
import getLeadsSaga from '../../../Manage_retail/redux/sagas/get_leads.saga';
import getUsersListSaga from '../../../Manage_retail/redux/sagas/get_users_list.saga';
import leadManageGetLeadsStatusSaga from '../../../Manage_retail/redux/sagas/lead_manage_get_lead_status.saga';

import changeLeadCustomerSaga from './change_lead_customer.saga';
import setLeadValuationSaga from './set_lead_valuation.saga';
import changeLeadStatusSaga from './change_lead_status.saga';
import addNoteSaga from './add_note.saga';
import delNoteSaga from './delNote.saga';
import getCapBrandsSaga from './cap.sagas/get_cap_brands.saga';
import getCapModelsSaga from './cap.sagas/get_cap_models.saga';
import getCapVersionsSaga from './cap.sagas/get_cap_versions.saga';
import getCapDerivativesSaga from './cap.sagas/get_cap_derivatives.saga';
import getCapRegistrationSaga from './cap.sagas/get_cap_registration.saga';
import getCapValuationSaga from './cap.sagas/get_cap_valuation.saga';
import getReferenceBikeSaga from './get_reference_bike.saga';
import getLeadsMotHistorySaga from './get_leads_mot_history.saga';
import setLeadsCustomerValuationSaga from './set_leads_customer_valuation.saga';
import sendEmailSaga from './send_email.saga';
import sendSMSSaga from './send_sms_saga';
import setLeadProfileDuplicateSaga from './set_lead_profile_duplicate.saga';
import getBikeBrandsSaga from '../../../Lead_create/redux/sagas/get_bike_brands.saga';
import searchLeadCountySaga from './search_lead_county.saga';
import addressLookupSaga from './address_lookup.saga';
import addDataByStreetsSaga from './add_data_by_streets.saga';
import updateBlemishReportSaga from './questions.sagas/update_blemish_report.saga';
import getLeadProfilePhotosSaga from './get_lead_profile_photos.saga';
import uploadLeadProfilePhotoSaga from './upload_lead_profile_photo.saga';
import createBikeHpiCheckSaga from './create_bike_hpi_check.saga';
import getBikeHpiCheckSaga from './get_bike_hpi_check.saga';
import setLeadApproveSaga from '../../../Lead_approval/redux/sagas/set_lead_approve.saga';
import changeRefBikeLeadSaga from './change_ref_bike_lead.saga';
import createLeadProfileLeadFinanceSaga from './create_lead_profile_lead_finance.saga';
import readLeadProfileLeadFinanceSaga from './read_lead_profile_lead_finance.saga';
import getLeadProfileWithNotesSaga from './get_lead_profile_with_notes.saga';
import setFinalConfirmationSaga from './set_final_confirmation.saga';
import getTransportUsersListSaga from './get_transport_users_list.saga';
import transferLeadToBikeSaga from './transer_lead_to_bike.saga';
import setCustomerNameSaga from './customer_name.saga';
import deleteLeadProfilePhotoSaga from './delete_lead_profile_photos.saga';
import getLeadHistorySaga from './get_lead_history.saga';
import { getLeadConversationSaga } from './get_lead_conversation.saga';
import { getLeadDispositionSaga } from './get_lead_disposition.saga';


// LeadPaymentApproval Sagas
import LEAD_PAYMENT_APPROVAL_GET_LEADS_SAGA from '../../../LeadPaymentApproval/redux/sagas/getLeads.saga';
import LEAD_PAYMENT_APPROVAL_GET_LEAD_DETAILS_SAGA from '../../../LeadPaymentApproval/redux/sagas/getLeadFinance.saga';
import LEAD_PAYMENT_APPROVAL_SAVE_LEAD_DETAILS_SAGA from '../../../LeadPaymentApproval/redux/sagas/saveLeadFinance.saga';
import LEAD_PAYMENT_APPROVAL_GET_DRIVERS_CATALOG from '../../../LeadPaymentApproval/redux/sagas/getDriversCatalog.saga';

// CustomersList Sagas
import LEAD_CUSTOMERS_LIST_GET_LEADS_SAGA from '../../../CustomersList/redux/sagas/leads.saga';

import LEAD_BIKE_MODEL_ADD_SUGGESTION_SAGA from './addPriceSuggestion';
import assignLeadDeliveryRequestedAgentSaga from '../../../Manage_retail/redux/sagas/assign_lead_delivery_requested_agent.saga';

export default function* leadsRootSaga() {
    yield all([
        getLeadProfileWithNotesSaga(),
        changeRefBikeLeadSaga(),
        getBikeBrandsSaga(),
        getLeadProfileSaga(),
        addDataByStreetsSaga(),
        getLeadProfilePhotosSaga(),
        deleteLeadProfilePhotoSaga(),
        uploadLeadProfilePhotoSaga(),
        addressLookupSaga(),
        searchLeadCountySaga(),
        getLeadsStatusSaga(),
        assignLeadSaga(),
        leadManageChangeLeadStatusSaga(),
        deleteLeadSaga(),
        getLeadsAffiliateSaga(),
        getLeadsDivisionsSaga(),
        getLeadsSaga(),
        getUsersListSaga(),
        leadManageGetLeadsStatusSaga(),

        changeLeadCustomerSaga(),
        setLeadValuationSaga(),
        changeLeadStatusSaga(),
        addNoteSaga(),
        delNoteSaga(),
        getCapBrandsSaga(),
        getCapModelsSaga(),
        getCapVersionsSaga(),
        getCapDerivativesSaga(),
        getCapRegistrationSaga(),
        getCapValuationSaga(),
        getBlemishReportSaga(),
        updateBlemishReportSaga(),
        getLeadsMotHistorySaga(),
        setLeadsCustomerValuationSaga(),
        sendEmailSaga(),
        sendSMSSaga(),
        setLeadProfileDuplicateSaga(),
        createBikeHpiCheckSaga(),
        getBikeHpiCheckSaga(),
        setLeadApproveSaga(),
        createLeadProfileLeadFinanceSaga(),
        readLeadProfileLeadFinanceSaga(),
        setFinalConfirmationSaga(),
        getTransportUsersListSaga(),
        transferLeadToBikeSaga(),
        getReferenceBikeSaga(),
        setCustomerNameSaga(),
        getLeadHistorySaga(),

        LEAD_PAYMENT_APPROVAL_GET_LEADS_SAGA(),
        LEAD_PAYMENT_APPROVAL_GET_LEAD_DETAILS_SAGA(),
        LEAD_PAYMENT_APPROVAL_SAVE_LEAD_DETAILS_SAGA(),
        LEAD_PAYMENT_APPROVAL_GET_DRIVERS_CATALOG(),

        LEAD_CUSTOMERS_LIST_GET_LEADS_SAGA(),

        LEAD_BIKE_MODEL_ADD_SUGGESTION_SAGA(),
        assignLeadDeliveryRequestedAgentSaga(),
        getLeadDispositionSaga(),
        getLeadConversationSaga(),
    ]);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/leads_root.saga.js